import {
  LUCIDE_DYNAMIC_IMPORT_KEYS,
} from "./lucide_icon_registry.generated";

const LUCIDE_PREFIX = "lucide:" as const;

function suggestClosestLucideIconKey(rawName: string): string | undefined {
  const trimmed: string = rawName.trim().toLowerCase();
  if (trimmed.length === 0) return undefined;

  const reversedParts: string = trimmed.split("-").filter(Boolean).reverse().join("-");
  if (LUCIDE_DYNAMIC_IMPORT_KEYS.has(reversedParts)) {
    return reversedParts;
  }

  const parts: string[] = trimmed.split("-").filter(Boolean);
  if (parts.length === 0) return undefined;

  const candidates: string[] = [...LUCIDE_DYNAMIC_IMPORT_KEYS].filter((key) =>
    parts.every((part) => key.includes(part)),
  );
  if (candidates.length === 0) {
    const partial: string[] = [...LUCIDE_DYNAMIC_IMPORT_KEYS].filter((key) =>
      parts.some((part) => key.includes(part)),
    );
    if (partial.length === 0) return undefined;
    partial.sort((a, b) => a.length - b.length);
    return partial[0];
  }
  candidates.sort((a, b) => a.length - b.length);
  return candidates[0];
}

/** English error for agent tools and HTTP API consumers. */
export function formatInvalidStoredIconError(
  input: string,
  rawLucideName: string,
): string {
  const suggestion: string | undefined = suggestClosestLucideIconKey(rawLucideName);
  const suggestionText: string =
    suggestion !== undefined
      ? ` Did you mean "${LUCIDE_PREFIX}${suggestion}"?`
      : "";
  return (
    `Invalid icon "${input}": not in the installed Lucide icon set.${suggestionText} ` +
    `Use a Unicode emoji or ${LUCIDE_PREFIX}<kebab-case> from Lucide ` +
    `(e.g. ${LUCIDE_PREFIX}clipboard-check, ${LUCIDE_PREFIX}inbox).`
  );
}
